import ICalculationNotification = ZoningAPI.ICalculationNotification;
import { getPrettyNotificationType } from '../enums';
import { ClonableItem } from './clonable-item';

export class CalculationNotification extends ClonableItem<ICalculationNotification>
    implements ICalculationNotification {
    label: string;
    type: number;
    code: number;
    message: string;

    constructor(value?: ICalculationNotification) {
        super(value);
    }

    public get typeStr() {
        return getPrettyNotificationType(this.type);
    }
}
